import { useState } from 'react';
import type { FormEvent } from 'react';
import { useT } from '../i18n/I18nProvider';
import { LANG_LABEL, LANGS } from '../i18n/dictionary';
import { login } from '../api/endpoints';
import type { SessionDto } from '../api/types';
import { primeAudio } from '../feedback/sound';

export function LoginScreen({ onDone }: { onDone: (session: SessionDto) => void }) {
  const { t, lang, setLang } = useT();
  const [name, setName] = useState('');
  const [pin, setPin] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    // AudioContext smí vzniknout jen po interakci – přihlášení je první tap směny.
    primeAudio();

    if (!name.trim() || !pin.trim()) {
      setError(t('loginErrEmpty'));
      return;
    }

    setPending(true);
    setError(null);
    try {
      // Odpověď nese i kontext směny včetně jazyka – žádné další volání.
      const session = await login(name.trim(), pin.trim());
      onDone(session);
    } catch {
      // Syrový text z API se uživateli nezobrazí.
      setError(t('loginErrFailed'));
    } finally {
      setPending(false);
    }
  }

  return (
    <div className="app">
      <header className="appbar">
        <span className="brand">{t('app')}</span>
        <span className="langs" role="group" aria-label="Jazyk / Language">
          {LANGS.map((l) => (
            <button key={l} type="button" aria-pressed={l === lang} onClick={() => setLang(l)}>
              {LANG_LABEL[l]}
            </button>
          ))}
        </span>
      </header>

      <div className="screen-pad center">
        <form className="card-plain" onSubmit={submit}>
          <h2 className="h2">{t('loginTitle')}</h2>
          <p className="p">{t('loginSubtitle')}</p>

          <label className="field">
            <span>{t('loginName')}</span>
            <input
              className="input"
              autoComplete="username"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>

          <label className="field">
            <span>{t('loginPin')}</span>
            <input
              className="input mono"
              type="password"
              inputMode="numeric"
              autoComplete="current-password"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
            />
          </label>

          <button className="btn primary" type="submit" disabled={pending}>
            {pending ? t('loginPending') : t('loginSubmit')}
          </button>

          {error && <p className="status err">{error}</p>}
        </form>
      </div>
    </div>
  );
}
